/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {UrlTree} from './url_tree';
/**
 * \@whatItDoes Provides a way to migrate AngularJS applications to Angular.
 * 
 * \@experimental
 * @abstract
 */
export abstract class UrlHandlingStrategy {
/**
 * Tells the router if this URL should be processed.
 * 
 * When it returns true, the router will execute the regular navigation.
 * When it returns false, the router will set the router state to an empty state.
 * As a result, all the active components will be destroyed.
 * 
 * @abstract
 * @param {?} url
 * @return {?}
 */
shouldProcessUrl(url: UrlTree) {}
/**
 * Extracts the part of the URL that should be handled by the router.
 * The rest of the URL will remain untouched.
 * @abstract
 * @param {?} url
 * @return {?}
 */
extract(url: UrlTree) {}
/**
 * Merges the URL fragment with the rest of the URL.
 * @abstract
 * @param {?} newUrlPart
 * @param {?} rawUrl
 * @return {?}
 */
merge(newUrlPart: UrlTree, rawUrl: UrlTree) {}
}
/**
 * \@experimental
 */
export class DefaultUrlHandlingStrategy implements UrlHandlingStrategy {
/**
 * @param {?} url
 * @return {?}
 */
shouldProcessUrl(url: UrlTree): boolean { return true; }
/**
 * @param {?} url
 * @return {?}
 */
extract(url: UrlTree): UrlTree { return url; }
/**
 * @param {?} newUrlPart
 * @param {?} wholeUrl
 * @return {?}
 */
merge(newUrlPart: UrlTree, wholeUrl: UrlTree): UrlTree { return newUrlPart; }
}


// WEBPACK FOOTER //
// ../../../../packages/router/src/url_handling_strategy.ts